<template>
  <div class="text-center py-4 mt-2 flex justify-center items-center">
    {{ message }}
    <sync-loader color="#73c8d2" size="8px" class="top-4 pl-2" />
  </div>
</template>
<script>
import SyncLoader from 'vue-spinner/src/SyncLoader.vue';
export default {
  name: 'LoadMoreIndicator',
  components: { SyncLoader },
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {};
  }
};
</script>
